<template>
  <div class="p-6">
    <div v-if="loading" class="flex justify-center items-center h-40">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <template v-else>
      <div class="mb-6">
        <router-link
          :to="{ name: 'Home' }"
          class="text-sm text-neutral-600 hover:text-neutral-900"
        >
          ← Назад
        </router-link>
      </div>

      <h1 class="text-2xl font-bold text-neutral-900 mb-6">{{ groupName }}</h1>

      <div v-if="modules.length === 0" class="text-neutral-500">
        Нет доступных модулей в этой группе
      </div>

      <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <router-link
          v-for="module in modules"
          :key="module.id"
          :to="`/${module.route}`"
          class="flex items-center gap-4 p-4 bg-white rounded-lg border border-neutral-200 hover:border-neutral-300 hover:shadow-md transition-all duration-150"
        >
          <div class="shrink-0 w-12 h-12 flex items-center justify-center bg-neutral-100 rounded-lg">
            <component
              :is="getIconComponent(module.key)"
              class="w-6 h-6 text-neutral-700"
            />
          </div>
          <div class="min-w-0">
            <h3 class="font-medium text-neutral-900 truncate">{{ module.name }}</h3>
            <p class="text-sm text-neutral-500">{{ getModuleTypeName(module.key) }}</p>
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import StorehouseIcon from '@/components/navigationIcons/StorehouseIcon.vue'
import OrdersIcon from '@/components/navigationIcons/OrdersIcon.vue'
import ProductionIcon from '@/components/navigationIcons/ProductionIcon.vue'
import ReceiptInvoiceControlIcon from '@/components/navigationIcons/ReceiptInvoiceControlIcon.vue'
import DefaultIcon from '@/components/navigationIcons/DefaultIcon.vue'

export default {
  components: {
    StorehouseIcon,
    OrdersIcon,
    ProductionIcon,
    ReceiptInvoiceControlIcon,
    DefaultIcon,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      groupFromApi: null,
    }
  },
  computed: {
    ...mapStores(useAuthStore),
    groupId() {
      return parseInt(this.id, 10)
    },
    modules() {
      const mods = this.authStore?.currentUser?.modules || []
      return mods.filter((m) => m.module_group_id === this.groupId)
    },
    groupName() {
      if (this.modules.length > 0 && this.modules[0].module_group) {
        return this.modules[0].module_group.name
      }
      return this.groupFromApi?.name || 'Группа'
    },
  },
  watch: {
    id: {
      handler() {
        this.fetchGroupIfNeeded()
      },
      immediate: true,
    },
  },
  methods: {
    getIconComponent(key) {
      switch (key) {
        case 'storehouse':
          return 'StorehouseIcon'
        case 'orders':
          return 'OrdersIcon'
        case 'production':
          return 'ProductionIcon'
        case 'receipt-invoice-control':
          return 'ReceiptInvoiceControlIcon'
        default:
          return 'DefaultIcon'
      }
    },
    getModuleTypeName(key) {
      const names = {
        storehouse: 'Склад',
        orders: 'Заказы',
        production: 'Производство',
        'receipt-invoice-control': 'Контроль приходных',
      }
      return names[key] || key
    },
    fetchGroupIfNeeded() {
      if (this.modules.length > 0) return
      this.loading = true
      axios
        .post('/api/moduleGroup/getModuleGroup', { id: this.groupId })
        .then((res) => {
          this.groupFromApi = res.data.data
        })
        .catch(() => {
          this.groupFromApi = null
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
